import { render, staticRenderFns } from "./morningmeetingTeacher.vue?vue&type=template&id=242cc1db&"
import script from "./morningmeetingTeacher.vue?vue&type=script&lang=js&"
export * from "./morningmeetingTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports